import { render } from "./TournamentInsightPage.vue?vue&type=template&id=f157bc40&scoped=true"
import script from "./TournamentInsightPage.vue?vue&type=script&lang=js"
export * from "./TournamentInsightPage.vue?vue&type=script&lang=js"

import "./TournamentInsightPage.vue?vue&type=style&index=0&id=f157bc40&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f157bc40"]])

export default __exports__